import React from "react";
import "./style.scss"
import { useNavigate } from "react-router-dom";

export default function Forbidden() {

  // const navigate=useNavigate();
  return (
    <div id="notfound">
      <div className="notfound">
        <div className="notfound-404">
          <h3>Access Denied</h3>
          <h1><span>4</span><span>0</span><span>1</span></h1>
        </div>
        <h2>we are sorry, but you are not athorized to access the requested page</h2>
        {/* <button  onClick={()=>navigate("/")} className="button" >
          Go Back
        </button> */}
      </div>
    </div>

  );
}

